import { configureStore } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory as createHistory } from 'history';
import createReducer from 'reducer';
import { combineReducers } from 'redux';
import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// eslint-disable no-underscore-dangle

// Build the middleware for intercepting and dispatching navigation actions
/*
// @ts-ignore - dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

*/
const persistConfigDefault = {
  key: 'root',
  version: 1,
  whitelist: [],
  storage,
};

/** Gets the global instance of the redux store */

const makeStore = () => {
  const history = createHistory();
  const reducer = createReducer(history);

  const _r = combineReducers(reducer);

  // @ts-ignore so I can get the state type
  const _s = _r(undefined, {});

  type State = typeof _s;

  const combinedReducer = persistCombineReducers<State>(
    persistConfigDefault,
    reducer,
  );

  const store = configureStore({
    reducer: combinedReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: true,
        immutableCheck: false, // TODO - fix immutable errors
      }).concat([routerMiddleware(history)]),
  });

  return {
    history,
    reducer,
    store,
    getStore: () => store,
  };
};

export const { history, reducer, store, getStore } = makeStore();
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export interface AppDispatchProp {
  dispatch: AppDispatch;
}
